import React, { useEffect, useState } from 'react';
import { Capa, Photo } from './styles';
import { Link, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import SliderComponent from '../SliderComponent';
import api from '../../../../services/api';
import { urlWebsite } from '../../../../config';
import { FaArrowCircleRight, FaArrowRight, FaBrain, FaChevronRight, FaDownload } from 'react-icons/fa';
import { useAuth } from '../../../../hooks/Auth';
import downloadit from '../../../../utils/download';
import sendTrack from '../../../../utils/sendTracking';
import { useLanguage } from '../../../../hooks/Language';
import { Form } from '@unform/web';
import { useConfiguration } from '../../../../hooks/Configuration';
import { dateFullWithHour, makeText } from '../../../../utils/date';
 

interface IParams {
  projectHash : string;
  eventHash : string;
}

const FaqFeature : React.FC = () => {
 const {projectHash, eventHash} = useParams<IParams>();
  const {user} = useAuth();
  const [currentCategory,setCurrentCategory] = useState('files');
  const [filesList,setFilesList] = useState<Array<Record<string,any>>>([]);
  const [podcastsList,setPodcastsList] = useState<Array<Record<string,any>>>([]);
  const [slides, setSlides] = useState<Array<JSX.Element>>([] as Array<JSX.Element> );
  const [search,setSearch] = useState('');
  const {translate} = useLanguage();
  const {configuration} = useConfiguration();

  const load = async () => {
    const fileData = await api.get(`faq-list/${projectHash}`);
    if(fileData){

      fileData.data.rows.sort((a,b) => a.title > b.title ? 1 : a.title < b.title ? -1 : 0);

      setFilesList(fileData.data.rows);
    }
  }
 

  useEffect(() => {
    load();
 
  },[])

  const downloadItem =async ({category, title, url ,user_name = '', user_id = '' }) => {
sendTrack({category, title, url ,user_name, user_id, project_id: projectHash, event_id: eventHash})

  
  }




  useEffect(( ) => {
    const l : Array<JSX.Element> = [];
     filesList?.length > 0 && filesList.map( (event,index)  => {
 
       
      l.push(
      
      
       <div className='downloadItem'  key={event._id}  > 
     
   
      
      <div className='event-content'>
       <strong className='event-title' >{event.title}</strong>
     {event.description &&<p className='event-project' style={{minHeight: '0px'}} dangerouslySetInnerHTML={{__html: event.description}}/>}
      
       
      </div>
      
      
   </div>)
     }
    )

    setSlides(l);
  },[filesList])



  const newSearch = () => {

    const getSearch = [...filesList];
    const newslides : Array<JSX.Element> = [];

    

    const newList = getSearch.map( event => {
      
      if( !search || event.title.toLowerCase().indexOf(search.toLowerCase()) >= 0 ) {
        newslides.push(     
          <div className='downloadItem' key={event._id} >
           
          
         <div className='event-content'>
          <strong className='event-title' style={{marginBottom: '10px'}}>{event.title}</strong>
         <p className='event-project' style={{minHeight: '0px'}} dangerouslySetInnerHTML={{__html: event.description}}/>
         </div>
         
         
         </div>);

        }

      
    });

    setSlides(newslides);

  }



    return     <>  { slides?.[0] &&  
    <Capa id="arquivos-apoio">

 


<aside style={{width: '100%', display: currentCategory === 'files' ? 'flex' : 'none', alignItems:'center', justifyContent:'flex-start', flexDirection: 'column'}}>
   <h1 style={{color: 'rgb(0, 14, 64)', textAlign:'center', margin: '20px auto'}}>FAQ</h1>

  <aside style={{width: '100%', display:'flex', alignItems:'center', justifyContent:'center'}}> <Form
          style={{ display: 'flex', alignItems: 'stretch', background:'none', margin:'5px' }}
          onSubmit={newSearch}
        >
          
           
          <input style={{height: '43px', padding: '10px'}}
            name="pesquisa"
            type="text"
            placeholder={`${translate('Escreva para pesquisar')}...`}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

        <button style={{width: '100px',height: '43px', background:configuration?.theme_data?.primary_background? configuration?.theme_data?.primary_background : '#f16621', color: configuration?.theme_data?.primary_color ? configuration?.theme_data?.primary_color :  '#fff', borderRadius:'10px', border: '0px',  margin: '0px 5px'}} type="submit">{translate('Pesquisar')}</button>
        </Form></aside>
    
    <div className='event-list-container'>
{slides.length > 0 ? slides : <h2>Nenhum arquivo disponível.</h2>}
    </div>
   </aside>
  </Capa>} </>
}

export default FaqFeature;